import { QuotationStatusDTO } from "./quotation-status-dto";

export class SearchQuote {
    quotationStatus: QuotationStatusDTO;
    applicantName: string = "";
    panNumber: string = "";
    quoteDate: string = "";
    phoneNo: string = "";
    dob: string = "";
    applicationNo: string = "";
    docFlag:boolean=false;

    constructor() {
        this.quotationStatus = new QuotationStatusDTO();
    }
}
